"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArticleCard = void 0;
var tslib_1 = require("tslib");
// @ts-ignore
var can_1 = tslib_1.__importDefault(require("can"));
require("components/card/article/article");
require("components/timeline/animation-item/animation-item");
var React = tslib_1.__importStar(require("react"));
var ReactCanWrapper_1 = require("../../../../ReactCanWrapper");
require("./styles.less");
function ArticleCard(props) {
    var options = new can_1.default.Map(props.options);
    var template = "<animation-item\n                        {timeline-type}=\"gs-timeline\"\n                        {is-embed}=\"false\"\n                        ><card-article\n                        timeline-type=\"gs-timeline\"\n                        card-index=\"{{cardIndex}}\"\n                        fromtimeline=\"true\"\n                        ></card-article></animation-item>";
    return (React.createElement("div", { className: 'rating-row-wrapper' },
        React.createElement(ReactCanWrapper_1.ReactCanWrapper, { className: 'm-gs-timeline__card', options: options, template: template })));
}
exports.ArticleCard = ArticleCard;
